<template>
  <div
    class="flex flex-col items-center justify-center w-full py-6 px-4 text-center"
    :class="compact ? 'min-w-[220px]' : 'col-span-full'"
  >
    <!-- Ikon -->
    <div class="relative mb-3">
      <!-- Ikon wifi-off saat error final -->
      <div v-if="!isRetrying" class="w-12 h-12 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center">
        <svg class="w-6 h-6 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.14 0M1.394 9.393c4.686-4.686 12.284-4.686 16.97 0" />
          <line x1="2" y1="2" x2="22" y2="22" stroke-linecap="round" stroke-width="1.5" />
        </svg>
      </div>

      <!-- Spinner saat retry -->
      <div v-else class="w-12 h-12 rounded-full bg-blue-50 dark:bg-blue-900/30 flex items-center justify-center">
        <svg class="w-6 h-6 text-blue-500 dark:text-blue-400 animate-spin" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
      </div>
    </div>

    <!-- Teks status -->
    <div v-if="isRetrying" class="text-xs text-blue-500 dark:text-blue-400 font-medium mb-1">
      <span v-if="retryCount > 0"> Memuat ulang... (Percobaan {{ retryCount }}/3) </span>
      <span v-else> Memuat ulang... </span>
    </div>
    <div v-else class="space-y-1">
      <h3 v-if="title" class="text-sm font-semibold text-[#293146] dark:text-gray-200">{{ title }}</h3>
      <p class="text-xs text-gray-400 dark:text-gray-500 max-w-[180px] leading-relaxed mx-auto">
        {{ message }}
      </p>
    </div>

    <!-- Tombol aksi — hanya tampil setelah semua retry gagal -->
    <div v-if="!isRetrying && showRetryButton" class="flex gap-2 mt-3">
      <button
        @click="$emit('retry')"
        class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-lg bg-[#293146] hover:bg-[#1e263a] text-white dark:bg-gray-600 dark:hover:bg-gray-500 transition-colors"
      >
        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        {{ retryText }}
      </button>
      <button
        v-if="showRefreshButton"
        @click="$emit('refresh')"
        class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-600 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-300 transition-colors"
      >
        {{ refreshText }}
      </button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: 'Terjadi Kesalahan',
  },
  message: {
    type: String,
    default: 'Tidak dapat memuat data.',
  },
  isRetrying: {
    type: Boolean,
    default: false,
  },
  retryCount: {
    type: Number,
    default: 0,
  },
  showRetryButton: {
    type: Boolean,
    default: true,
  },
  showRefreshButton: {
    type: Boolean,
    default: true,
  },
  retryText: {
    type: String,
    default: 'Coba Lagi',
  },
  refreshText: {
    type: String,
    default: 'Muat Ulang Halaman',
  },
  // compact=true untuk dipakai dalam slider horizontal (recommended)
  compact: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['retry', 'refresh']);
</script>
